import { Component, Input } from '@angular/core';
import { CompanyLogoConfiguration } from 'src/app/models/auxiliary/company-logo-configuration';
import { CommonDataService } from 'src/app/sections/common/services/common-data.service';

@Component({
  selector: 'app-user-logs-list-report',
  templateUrl: './user-logs-list-report.component.html',
  styleUrls: ['./user-logs-list-report.component.scss']
})
export class UserLogsListReportComponent {

  @Input() reportId: string;
  @Input() data: [];
  companyLogo: CompanyLogoConfiguration = null;

  date= new Date();

  constructor(public commonDataService: CommonDataService) {
    this.companyLogo = new CompanyLogoConfiguration();
  }
  ngOnInit() {
    this.commonDataService.getCompanyLogo().subscribe((labConfiguration: CompanyLogoConfiguration) => {
      this.companyLogo = labConfiguration;
    });
  }
}
